<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useFileAttachments } from '@/composables/useFileAttachments';
import { watch, toRefs } from 'vue';
import FileAttachmentItem from '@/components/library/attachments/FileAttachmentItem.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const { t } = useI18n();

const props = defineProps<{
  mediaId: string;
}>();

const propRef = toRefs(props);

const { isLoading, fetchAttachments, fileAttachments } = useFileAttachments({
  mediaId: propRef.mediaId,
});

watch(
  propRef.mediaId,
  async () => {
    await fetchAttachments(props.mediaId);
  },
  { immediate: true },
);
</script>

<template>
  <div
    v-if="isLoading"
    class="bg-neutral-100 flex items-center justify-center p-4"
  >
    <font-awesome-icon
      :icon="['far', 'spinner']"
      class="text-base text-neutral-500 animate-spin"
    />
  </div>
  <div v-if="fileAttachments.length">
    <div class="my-2 pb-1 border-b border-neutral-300">
      <span class="font-semibold text-lg">
        {{ t('fileAttachments.title') }}
      </span>
    </div>
    <div class="flex flex-col gap-2">
      <file-attachment-item
        v-for="attachment in fileAttachments"
        :key="attachment.id"
        :attachment="attachment"
      />
    </div>
  </div>
</template>
